export const SITE_URL = 'https://www.groupeouambo.com';
export const OG_IMAGE = `${SITE_URL}/og-image.png`;

export const organizationLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Groupe Ouambo',
  url: SITE_URL,
  logo: `${SITE_URL}/groupeouambologo.png`,
  parentOrganization: {
    '@type': 'Corporation',
    name: 'Kesse Inc.',
    url: 'https://www.kesseinc.com',
  },
  sameAs: [
    'https://www.kesseinc.com',
    'https://www.kessedesk.com',
    'https://www.onboardlearning.org',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'info@groupeouambo.com',
    contactType: 'customer support',
    availableLanguage: ['English', 'French'],
  },
};

const pages = {
  en: {
    home: {
      title: 'Groupe Ouambo | Technology & Digitalization',
      description:
        'Groupe Ouambo builds AI-enabled platforms for education, commerce, and operations. Parent company: Kesse Inc. (US C-corporation).',
      path: '/',
    },
    about: {
      title: 'About | Groupe Ouambo',
      description:
        'Learn who Groupe Ouambo is: a technology and digitalization group building practical platforms, with Kesse Inc. as parent company.',
      path: '/about',
    },
    transport: {
      title: 'Transport & logistics | Groupe Ouambo',
      description:
        'Transport and logistics services from Groupe Ouambo — corridor delivery and operational support for businesses and institutions.',
      path: '/transport',
    },
    investment: {
      title: 'Investment & partnerships | Groupe Ouambo',
      description:
        'Explore investment and partnership opportunities with Groupe Ouambo across technology, logistics, and digital platforms.',
      path: '/investment',
    },
    technology: {
      title: 'Technology & AI | Groupe Ouambo',
      description:
        'AI and digital platforms from Groupe Ouambo, including OnboardLearning, Galababa, and KesseDesk — built for real operations.',
      path: '/technology',
    },
    equipment: {
      title: 'Equipment | Groupe Ouambo',
      description:
        'IT equipment and deployment options from Groupe Ouambo for institutions and businesses.',
      path: '/equipment',
    },
    contact: {
      title: 'Contact | Groupe Ouambo',
      description:
        'Contact Groupe Ouambo in English or French. Email info@groupeouambo.com or use the contact form.',
      path: '/contact',
    },
    careers: {
      title: 'Careers | Groupe Ouambo',
      description:
        'Careers at Groupe Ouambo — join a bilingual technology and digitalization team.',
      path: '/careers',
    },
  },
  fr: {
    home: {
      title: 'Groupe Ouambo | Technologie et digitalisation',
      description:
        'Groupe Ouambo conçoit des plateformes assistées par l’IA pour l’éducation, le commerce et les opérations. Société mère : Kesse Inc. (C-corporation américaine).',
      path: '/',
    },
    about: {
      title: 'À propos | Groupe Ouambo',
      description:
        'Découvrez Groupe Ouambo : un groupe de technologie et de digitalisation, filiale de Kesse Inc.',
      path: '/about',
    },
    transport: {
      title: 'Transport et logistique | Groupe Ouambo',
      description:
        'Services de transport et logistique de Groupe Ouambo — livraison et appui opérationnel pour entreprises et institutions.',
      path: '/transport',
    },
    investment: {
      title: 'Investissement et partenariats | Groupe Ouambo',
      description:
        'Opportunités d’investissement et de partenariat avec Groupe Ouambo dans la technologie, la logistique et les plateformes numériques.',
      path: '/investment',
    },
    technology: {
      title: 'Technologie et IA | Groupe Ouambo',
      description:
        'Plateformes d’IA et de digitalisation de Groupe Ouambo, dont OnboardLearning, Galababa et KesseDesk.',
      path: '/technology',
    },
    equipment: {
      title: 'Équipements | Groupe Ouambo',
      description:
        'Équipements informatiques et déploiement proposés par Groupe Ouambo pour institutions et entreprises.',
      path: '/equipment',
    },
    contact: {
      title: 'Contact | Groupe Ouambo',
      description:
        'Contactez Groupe Ouambo en français ou en anglais. info@groupeouambo.com ou formulaire de contact.',
      path: '/contact',
    },
    careers: {
      title: 'Carrières | Groupe Ouambo',
      description:
        'Carrières chez Groupe Ouambo — rejoignez une équipe bilingue de technologie et de digitalisation.',
      path: '/careers',
    },
  },
};

const pathToKey = {
  '/': 'home',
  '/about': 'about',
  '/transport': 'transport',
  '/investment': 'investment',
  '/technology': 'technology',
  '/equipment': 'equipment',
  '/contact': 'contact',
  '/careers': 'careers',
};

export function pageSeo(lang, pathname) {
  const pack = pages[lang === 'fr' ? 'fr' : 'en'] || pages.en;
  const base = (pathname || '/').split('?')[0];
  if (base.startsWith('/equipment/')) {
    return {
      ...pack.equipment,
      title: lang === 'fr' ? 'Équipement | Groupe Ouambo' : 'Equipment item | Groupe Ouambo',
      path: base,
    };
  }
  const key = pathToKey[base] || 'home';
  return pack[key] || pack.home;
}
